import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MatRadioModule} from "@angular/material/radio";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatListModule} from "@angular/material/list";
import {CommonModule} from "@angular/common";
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatOptionModule} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import {HttpService} from "../../services/http/http.service";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'conoscenze-abilita-dialog',
  templateUrl: './conoscenze-abilita-dialog.component.html',
  styleUrls: ['./conoscenze-abilita-dialog.component.scss'],
  standalone: true,
  imports: [MatRadioModule, MatDatepickerModule, MatListModule, CommonModule, MatDialogModule, MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule, MatIconModule, MatOptionModule, MatSelectModule],
})
export class ConoscenzeAbilitaDialog implements OnInit {
  //onAddClick = new EventEmitter();

  descrizione: string = '';


  constructor(
    public dialogRef: MatDialogRef<ConoscenzeAbilitaDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: HttpService,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {

  }

  save() {


    if (this.data.type === 'conoscenze') {
      let data = {'id':null,'descrizione':this.descrizione}
      this.api.saveConoscenza(data).subscribe({
        next: (response: any) => {
          this.snackBar.open('Conoscenza creata con successo', 'close', { panelClass: 'successSnack' });
          this.dialogRef.close();
        }
      });
    } else if (this.data.type === 'abilita') {
      let data = {'id':null,'descrizione':this.descrizione}
      this.api.saveAbilita(data).subscribe({
        next: (response: any) => {
          this.snackBar.open('Abilità creata con successo', 'close', { panelClass: 'successSnack' });
          this.dialogRef.close();
        }
      });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
